import { Component, DestroyRef, inject, OnInit, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective } from '@ngx-translate/core';
import { RouterBaseService } from '../../../services/router/router-base.service';
import { ButtonComponent } from '../../../components/button/button.component';
import { DividerComponent } from '../../../components/panel/divider.component';
import { NotificationComponent } from '../../../components/notification/notification.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { W8BenFormErrorComponent } from '../w8ben-form-error/w8ben-form-error.component';

import { W8BenFormService } from '../w8ben-form.service';
import { W8BenModalName, W8BenProfile } from '../w8ben-form.domain';
import { W8BenFormAnalyticsService } from '../w8ben-form-analytics.service';
import { DetailedLoadingIndicatorComponent } from '../../../components/detailed-loading-indicator/detailed-loading-indicator.component';

@Component({
  selector: 'td-wb-w8ben-preview',
  templateUrl: 'w8ben-form-preview.component.html',
  styleUrls: ['w8ben-form-preview.component.scss'],
  imports: [
    DividerComponent,
    ButtonComponent,
    TranslateDirective,
    W8BenFormErrorComponent,
    NotificationComponent,
    HrefDirective,
    DetailedLoadingIndicatorComponent
  ]
})

export class W8BenFormPreviewComponent implements OnInit {
  private readonly routerService = inject(RouterBaseService);
  private readonly w8benFormService = inject(W8BenFormService);
  private readonly w8BenFormAnalyticsService = inject(W8BenFormAnalyticsService);

  readonly retainData = input<boolean>(false);
  protected profile = signal<W8BenProfile | undefined>(undefined);
  protected loading = signal(false);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.w8BenFormAnalyticsService.setTaggingData(W8BenModalName.UPDATE, 'n/a');
    if (this.w8benFormService.profile && this.retainData()) {
      this.profile.set(this.w8benFormService.profile);
    } else {
      this.loading.set(true);
      this.w8benFormService.getProfile()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: (profile: W8BenProfile) => {
            this.profile.set(profile);
            this.loading.set(false);
          },
          error: (): void => {
            this.loading.set(false);
          },
          complete(): void {
          }
        });
    }
  }

  protected getModalId(): string {
    return this.w8BenFormAnalyticsService.getModalId();
  }

  protected showSin(): boolean {
    return this.w8benFormService.isTaxResidencyCanada() ||
           (this.getSin() !== '' && !this.profile()?.ftinNotRequired);
  }

  protected onClickUpdate(): void {
    this.routerService.go('modal.w8ben.update');
  }

  protected onClickConfirm(): void {
    this.routerService.go('modal.w8ben.tax_residency_benefits');
  }

  protected getSin(): string {
    return this.w8benFormService.getIdentification();
  }

  protected requiredFieldMissing(): boolean {
    return !this.profile()?.citizenship ||
           !this.profile()?.birthDt ||
           (this.profile()?.legalName ?? '').trim() === '';
  }

  protected addressMissing(): boolean {
    return !this.profile()?.residenceAddressLines?.some((line: string) => line.trim() !== '');
  }
}

